module.exports = __webpack_public_path__ + "static/tobi-lutke-a5d3964789718ba7460debe800c36a9e.jpg";